import React from "react";
import { Button, Input, InputGroup, Form } from "reactstrap";

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";


const FiltroComponent = ({
  rangofechas,
  onChange,
  onSubmit,
  onSubmitfilt,
  search,
  onChangefilt,
  resetSearch,
  resetFilter,
}) => {
  return (
    <React.Fragment>
      <>
       
   

            
            <InputGroup>
              <Form className="search-box mt-2" onSubmit={onSubmitfilt}>
                <InputGroup>
                  <Input
                    type="text"
                    className="form-control"
                    name="search"
                    placeholder="Buscar"
                    value={search}
                    onChange={onChangefilt}
                  />
                  <i className="bx bx-search-alt search-icon" />
                  <Button color="primary" onClick={resetSearch}>
                    <span className=" bx bx-x fa-lg align-middle"></span>
                  </Button>
                </InputGroup>
              </Form>
            </InputGroup>
          
        

      
      </>
    </React.Fragment>
  );
};

export default FiltroComponent;
